import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.9 15.9"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8 15.9c-4.4 0-8-3.6-8-8 0-2.1.8-4.1 2.3-5.6 3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3c-1.5 1.5-3.5 2.3-5.6 2.3M8 1C4.1 1 1 4.1 1 8c0 1.8.7 3.6 2 4.9 2.7 2.7 7.1 2.7 9.9 0s2.7-7.1 0-9.9C11.6 1.7 9.8 1 8 1M7 2.9h2v2H7zm3 10H6v-2h1v-3H6v-2h3v5h1z" />
  </svg>
);
const SvgInfoCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="info-circle" {...props} />;
export default SvgInfoCircle;
